import { render, staticRenderFns } from "./TableRolesPerfiles.vue?vue&type=template&id=67d4315c&scoped=true"
import script from "./TableRolesPerfiles.vue?vue&type=script&lang=js"
export * from "./TableRolesPerfiles.vue?vue&type=script&lang=js"
import style0 from "./TableRolesPerfiles.vue?vue&type=style&index=0&id=67d4315c&prod&scoped=true&lang=css"
import style1 from "spinkit/spinkit.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d4315c",
  null
  
)

export default component.exports